module.exports = __webpack_public_path__ + "img/icon-lock.cd95df2a.svg";